export var IngestionPartitionSortField;
(function (IngestionPartitionSortField) {
    IngestionPartitionSortField["INGESTION_PARTITION_SORT_FIELD_CREATED_AT"] = "createdAt";
    IngestionPartitionSortField["INGESTION_PARTITION_SORT_FIELD_PARTITION_VALUE"] = "partitionValue";
    IngestionPartitionSortField["INGESTION_PARTITION_SORT_FIELD_LAST_SEEN_AT"] = "lastSeenAt";
})(IngestionPartitionSortField || (IngestionPartitionSortField = {}));
